import { useState } from 'react';
import Link from 'next/link';
import { getCookieValue, createUrl, mapSiteIdToNameMO } from '@/helpers/utils/siteUtils';
import {
  COOKIE_KEYS,
  CUSTOMER_DETAILS_PAGE_PATH,
  SITE_KEY_MAP_MO,
} from '../../../../../../../../../constants/constant';
const Index = ({
  data,
  Texts,
  showAllDivsions,
  selectedCustomerData,
  mailingRecordId,
}: {
  data?: { divisionsData: string[]; accountNumber: string };
  Texts: any;
  showAllDivsions?: boolean;
  selectedCustomerData?: any;
  mailingRecordId: string;
}) => {
  const [showAll, setShowAll] = useState(showAllDivsions);
  const selectedDivisionCode = getCookieValue(COOKIE_KEYS?.selectedSite)?.slice(0, 2);
  if (!data?.divisionsData || data?.divisionsData?.length === 0) {
    return <div className="font-medium text-blueLight underline">{Texts?.noSites || 'No sites available'}</div>;
  }

  const siteDetails = mapSiteIdToNameMO(data?.divisionsData);

  const currentSiteIndex = siteDetails.findIndex((item) => item.value === selectedDivisionCode);

  let selectedDivisionExistForCustomer = true;

  if (currentSiteIndex > -1) {
    siteDetails.unshift(siteDetails.splice(currentSiteIndex, 1)[0]);
  } else {
    selectedDivisionExistForCustomer = false;
  }

  let displayText;

  if (siteDetails.length > 0) {
    displayText = (
      <>
        {!selectedDivisionExistForCustomer && (
          <span className="mb-1 inline-block rounded border-gray-300 bg-gray-300 p-1 font-medium opacity-50">
            {selectedDivisionCode && SITE_KEY_MAP_MO?.[selectedDivisionCode]}
          </span>
        )}
        {showAll ? (
          siteDetails.map((detail) => (
            <div key={`key_${detail?.value}`} className={`block p-1 pl-0 pt-0 font-medium text-blueLight underline`}>
              <Link
                href={`/${CUSTOMER_DETAILS_PAGE_PATH}/${createUrl(
                  selectedCustomerData?.customerId,
                  selectedCustomerData?.accountNumber,
                  detail.value,
                  '',
                  mailingRecordId,
                )}`}
              >
                {detail.name}
              </Link>
            </div>
          ))
        ) : (
          <>
            <div>
              <span className={`inline-block p-1 pl-0 pt-0 font-medium text-blueLight underline`}>
                <Link
                  href={`/${CUSTOMER_DETAILS_PAGE_PATH}/${createUrl(
                    selectedCustomerData?.customerId,
                    selectedCustomerData?.accountNumber,
                    siteDetails[0]?.value,
                    '',
                    mailingRecordId,
                  )}`}
                >
                  {siteDetails[0]?.name}
                </Link>
              </span>
            </div>
            {siteDetails.length > 1 && (
              <button className="p-1 pl-0 text-blueLight underline" onClick={() => setShowAll(true)}>
                &amp; {siteDetails.length - 1} more
              </button>
            )}
          </>
        )}
      </>
    );
  }

  return <div>{displayText}</div>;
};

export default Index;
